import { OwcTypography, OwcTooltip } from "@one/react";
import PropTypes from "prop-types";
import {projectDisplayText} from "../../../../features/user/redux/selectors";
import { useSelector } from "react-redux";

const ProjectInfo = ({ projectId, redPandaProjects, client, user }) => {

  const tooltipId = `attr_${projectId}`;
  const displayText = useSelector((state) => projectDisplayText(state, redPandaProjects, projectId));
  const projectLabelStyle = { maxWidth: "340px", display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };

  return (
    <div>
      <OwcTypography variant="caption">{redPandaProjects?.length ? 'Projects' : 'Project'}</OwcTypography>

      <OwcTypography
        variant="button"
        id={tooltipId}
        style={projectLabelStyle}
      >
        {displayText}
      </OwcTypography>
      {displayText && (
        <OwcTooltip anchor={tooltipId}>
           <span style={{ whiteSpace: "pre-line" }}>
              {displayText?.replaceAll(", ", "\n")}
            </span>
        </OwcTooltip>
      )}
    </div>
  );
};

ProjectInfo.propTypes = {
  projectId: PropTypes.string,
  redPandaProjects: PropTypes.array,
  client: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired
};

export default ProjectInfo;
